export enum DataEntryRoutes {
  Assessments = 'Assessments',
}

export const DataEntryRoutesStates = {
  Assessments: 'main.school.data-entry.assessments',
};
